import client from "./client";

export const authApi = {
  login: (username: string, password: string) =>
    client.post<{ token: string; userId: number }>("/auth/login", { username, password }),

  me: () =>
    client.get<{ id: number; username: string; createdAt: string }>("/auth/me"),
};
